import React from 'react';
import { BookOpen, ArrowRight, ExternalLink, Play } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';

const DocsPage = () => {
  const sections = [
    { title: 'Primeiros Passos', desc: 'Como criar sua conta e primeiro bot', link: '#' },
    { title: 'WhatsApp Setup', desc: 'Conectar sua conta do WhatsApp Business', link: '#' },
    { title: 'Construtor de Fluxos', desc: 'Criar automações visuais', link: '#' },
    { title: 'Integrações', desc: 'Conectar com Stripe, Zapier e mais', link: '#' },
    { title: 'API Reference', desc: 'Documentação técnica da API', link: '#' },
    { title: 'FAQ', desc: 'Perguntas frequentes', link: '#' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
          <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <BookOpen className="h-4 w-4" />Documentação
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Central de <span className="text-[#3b82f6]">Ajuda</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-12">Tudo que você precisa para dominar o ChatAlfa.</p>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {sections.map((section) => (
              <Card key={section.title} className="hover:shadow-lg transition-shadow cursor-pointer group">
                <CardContent className="p-6">
                  <h3 className="font-bold text-lg mb-2 group-hover:text-[#3b82f6] transition-colors">{section.title}</h3>
                  <p className="text-gray-600 text-sm mb-4">{section.desc}</p>
                  <Button variant="ghost" className="text-[#3b82f6] p-0 h-auto">
                    Ver mais <ExternalLink className="h-4 w-4 ml-2" />
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        <div className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="bg-gradient-to-br from-purple-600 to-pink-600 text-white">
              <CardContent className="py-12 text-center">
                <Play className="h-12 w-12 mx-auto mb-4" />
                <h2 className="text-2xl font-bold mb-4">Curso Gratuito no Udemy</h2>
                <p className="text-purple-200 mb-6">Aprenda a dominar chatbots com WhatsApp e ChatGPT</p>
                <Button variant="secondary" size="lg" className="bg-white text-purple-600 hover:bg-gray-100">
                  Acessar curso grátis <ExternalLink className="ml-2 h-4 w-4" />
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
export default DocsPage;
